import React, { Component } from 'react';
import './App.css';


  let baseClass = 'filterButton ';

class FilterButton extends Component {
constructor(props) {
      super(props);
      this.state = { 
        selected:false,
      }
      this.handleButtonClick = this.handleButtonClick.bind(this)
    
    }

    componentDidMount(){
      //console.log("componentDidMount fired")
      this.props.reg(this)
      this.initLogoGrid()
    }

    handleButtonClick(){
      console.log('update logogrid from FilterButton'+JSON.stringify(this.props))
      this.props.updateSelected(this)
      this.props.action()
      this.setState({selected:true})
    }

    initLogoGrid(){
      console.log('init logo grid'+JSON.stringify(this.props)+'|'+this.props.buttonProps.label)
      if (this.props.buttonProps.label==="Most Recent") {
        console.log('This is the one'+this.props.buttonProps.selectedStyle)
        this.setState({selected:true})
      }
    }

  render() {
     var displayClasses = baseClass+this.props.buttonProps.colorStyle;
     var selectClasses=baseClass+this.props.buttonProps.selectedStyle
     
    return (
            <div className={this.state.selected ? selectClasses : displayClasses} onClick={this.handleButtonClick}>{this.props.buttonProps.label}</div>
    );
  }
}

export default FilterButton;




// WEBPACK FOOTER //
// ./src/FilterButton.js